import React, { useState, useEffect } from 'react';
import { Card, Typography, Button, Space } from 'antd';
import { CalendarOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { maximoApi, Team } from '../../lib/maximoApi';
import WorkOrderCalendar from '../../components/WorkOrderCalendar';

const { Title, Text } = Typography;

const DemoMaximoCalendar: React.FC = () => {
  const [teams, setTeams] = useState<Team[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTeams();
  }, []);

  const loadTeams = async () => {
    try {
      setLoading(true);
      const teamsRes = await maximoApi.getTeams();
      setTeams(teamsRes.data);
    } catch (error) {
      console.error('Demo Calendar: Error loading teams:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between mb-6 px-1">
        <div className="flex items-center gap-3">
          <CalendarOutlined style={{ fontSize: '24px', color: '#ec4899' }} />
          <div>
            <Title level={2} className="mb-0">
              Maximo Calendar Demo
            </Title>
            <Text type="secondary">
              Interactive calendar view of work orders by team
            </Text>
          </div>
        </div>
        
        <Space>
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => window.history.back()}
          >
            Back to Work Orders
          </Button>
        </Space>
      </div>

      {/* Calendar Container */}
      <Card 
        className="flex-1"
        styles={{
          body: {
            height: 'calc(100vh - 200px)',
            padding: 0
          }
        }}
      >
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <div className="text-center">
              <CalendarOutlined style={{ fontSize: '48px', color: '#ec4899', marginBottom: '16px' }} />
              <Text>Loading calendar data...</Text>
            </div>
          </div>
        ) : (
          <WorkOrderCalendar
            teams={teams}
            onClose={() => window.history.back()}
          />
        )}
      </Card>
    </div>
  );
};

export default DemoMaximoCalendar;